<template>
  <div>
    <button
      :disabled="disabled"
      class="btn btn-light"
      @click="onclickPrint"
    >
      <i class="fas fa-print"/>
    </button>

    <print-orders
      :orders="orders"
      :total_price="totalPrice"
      :created_at="moment().format('D/M/Y H:mm')"
      :font_size="getShopInfo.settings.apps.pos.receipt.font_size"
      class="receipt-template"
      style="position: fixed;z-index: -1;top: 1mm;left: 1mm;font-family: tahoma;color: black;width: 100%;"
    />
  </div>
</template>

<script>
import PrintOrders from '@/components/custom/print/pos/Orders.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    PrintOrders,
  },

  data () {
    return {
      orders: [],
      totalPrice: {},
    }
  },

  computed: {
    ...mapGetters({
      getShopInfo: 'getShopInfo',
      pos: 'getPos',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
    }),
    disabled () {
      return this.orders.length === 0
    },
  },

  watch: {
    'pos.orders': {
      handler: function () {
        this.updateData()
      },
      deep: true,
    },
  },

  created () {
    this.updateData()
  },

  methods: {
    updateData () {
      this.orders = this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      this.totalPrice = _.cloneDeep(this.getPosTotalPriceById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      }, this.mixin))
    },
    onclickPrint () {
      // eslint-disable-next-line no-undef
      $('.receipt-template').printThis()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/PrintButton.vue